import { render, staticRenderFns } from "./PhoenixBoxAction.vue?vue&type=template&id=02de6252"
import script from "./PhoenixBoxAction.vue?vue&type=script&lang=js"
export * from "./PhoenixBoxAction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports